import axios from "axios";
import { eventBus } from './eventBus';

export const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    Accept: "application/json",
    "Cg-CSRF-CH": "sCtmejAAJ6", // Aggiungo un header custom
  },
});

// Reporting/ranking endpoints validate the `tags` query param as a JSON string.
// axios 0.31.x serializes object params with bracket notation (`tags[foo]=bar`),
// so stringify an object `tags` before sending. Arrays and non-object values are
// left untouched, keeping native 0.31.x serialization for every other param.
// Wrap the request config at the call sites that can carry a `tags` object:
//   apiClient.get(url, withTagsParam(opt))
export function withTagsParam(config) {
  if (!config || !config.params || !config.params.tags
      || typeof config.params.tags !== 'object'
      || Array.isArray(config.params.tags)) {
    return config;
  }
  return { ...config, params: { ...config.params, tags: JSON.stringify(config.params.tags) } };
}

apiClient.interceptors.request.use((config) => {
  const activeRole = localStorage.getItem('activeRole');

  if (activeRole) {
    config.headers['X-Active-Role'] = activeRole;
  }

  //  get masked state from localStorage
  const maskedAccount = localStorage.getItem('mask');
  if (maskedAccount) {
    config.headers['X-Account-ID'] = maskedAccount
  }
  // console.log(' headers:', config.headers)
  return config
})

apiClient.interceptors.response.use((response) => {
  return response;
},
  (error) => {
    console.log(error)
    if (error.response && error.response.status && 401 === error.response.status) {
      eventBus.$emit('logout');
    }

    return Promise.reject(error);
  });
